import axios from "axios";
import {
  SET_FACTORY_FOR_USER,
  SET_QUERY_PARAMS,
  SET_USER_DETAILS,
  SET_EXISTING_JSON,
  UPDATE_LCL_SHIPMENT,
  SET_DELIVERY_SELECTED_EXISTING_FACTORY_NEW,
  UPDATE_AGENT_DETAILS,
  SET_CARD_SCHEDULE,
  SET_COMMODITY_CATEGORY_LIST,
  INSURANCE_AUTH_TOKEN
} from "../actions/types";
import { add_fcl_schedule_rates } from "./schedules";

import { updateErrorAndLoading } from "../actions";

export let GLOBAL_PROFIT_PERCENT = 1.12;
export let FCL_DELIVERY_FEE = 375;
export let LCL_DELIVERY_FEE = 12;
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_G_RECAPTCHA_SITE_KEY
const URL = window.location.href;
let LINK = URL.includes("primefreight.com");

if (URL.includes("localhost") || URL.includes("netlify.app")) {
  LINK = false;
}
export const BASE_API =
  LINK === false
    ? "https://primefreight-portal-dev.herokuapp.com/proxy-request?url=https://primefreight.betty.app/api/runtime/da93364a26fb4eeb9e56351ecec79abb"
    : "https://primefreight.betty.app/api/runtime/da93364a26fb4eeb9e56351ecec79abb";

export const sendBookingData = async (
  jwt_token,
  bookingData,
  booking_charges
) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };
  let query = {
    query: "mutation { action(id: $action_id input: $input)}",
    variables: {
      action_id:"346d9044bf2f47bb82881932ca342a39",
      input: {
        AgentProfileId: bookingData?.agentProfileID,
        style_nuumbers: booking_charges?.style_nuumbers,
        po_numbers: booking_charges?.po_number,
        pickup_section: booking_charges?.pickup_section,
        ers_section: booking_charges?.ers_section,
        booking: bookingData,
        port_origin_section: booking_charges?.port_origin_section,
        port_discharge_section: booking_charges?.port_discharge_section,
        delivery_section: booking_charges?.delivery_section,
        delivery_section_charges: booking_charges?.delivery_section_charges,
        discountID: booking_charges?.discountID,
        pickup_section_charges: booking_charges?.pickup_section_charges,
        insuranceArr: booking_charges?.insurances,
      },
    },
  };

  return axios.post(BASE_API, query, { headers }).then((response) => {
    if (response?.data?.data?.action?.results) {
      return [true, response?.data?.data?.action?.results];
    }
    return [false];
  });
};

export const sendNewShipperData = async (
  jwt_token,
  newShipper,
  isNewShipper
) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };

  let query = {
    query: "mutation { action(id: $action_id input: $input)}",
    variables: {
      action_id: "b0303eb5cd0c4ae59ca80f7c827638a9",
      input: {
        isNewShipper: isNewShipper,
        shipper_id: newShipper.id,
        country: newShipper.country,
        city: newShipper.city,
        port: newShipper.port.id,
        address: newShipper.address,
        business_name: newShipper.name,
        business_type: newShipper.business_type,
        contact_name: newShipper.contact_name,
        email: newShipper.email,
        postal: newShipper.postal,
        telephone_no: newShipper.phone_number,
      },
    },
  };

  return axios.post(BASE_API, query, { headers }).then((response) => {
    if (response.status === 200 || response.status === 201) {
      return {
        status: response.status,
        data: response.data,
      };
    } else {
      return {
        status: response.status,
        error: response.statusText,
      };
    }
  });
};

export const sendNewDeliveryLocationData = async (
  jwt_token,
  newDeliveryLocation,
  isNewDeliveryLoc
) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };
  let query = {
    query: "mutation { action(id: $action_id input: $input)}",
    variables: {
      action_id: "f2ce28eaf462451c812efc6c88166938",
      input: {
        isNewLocation: isNewDeliveryLoc,
        location_id: newDeliveryLocation.id,
        country: newDeliveryLocation.country,
        city: newDeliveryLocation.city,
        destination_city: newDeliveryLocation.port.id,
        address: newDeliveryLocation.address,
        business_name: newDeliveryLocation.name,
        business_type: newDeliveryLocation.business_type,
        contact_name: newDeliveryLocation.contact_name,
        email: newDeliveryLocation.email,
        postal: newDeliveryLocation.postal,
        phone_no: newDeliveryLocation.phone_number,
      },
    },
  };

  return axios.post(BASE_API, query, { headers }).then((response) => {
    if (response.status === 200 || response.status === 201) {
      return {
        status: response.status,
        data: response.data,
      };
    } else {
      return {
        status: response.status,
        error: response.statusText,
      };
    }
  });
};

export const sendbookingDataFromLandingPage = async (
  jwt_token,
  bookingObject,
  newBooking,
  form1,
  form2,
  insuranceArr,
  dutyTax
) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };
  let query = {
    query: "mutation { action(id: $action_id input: $input)}",
    variables: {
      action_id: "1bdf6ca2b7f84cd0bd341ec054290dc5",
      input: {
        pickup_section: bookingObject?.pickup_section,
        new_booking_form_info: newBooking,
        port_discharge_section:
          bookingObject?.port_discharge_section,
        port_origin_section: bookingObject?.port_origin_section,
        delivery_section_rate:
          bookingObject?.delivery_section_rate,
        booking_object: bookingObject?.booking_data,
        delivery_section: bookingObject?.delivery_section,
        ers_section: bookingObject?.ers_section,
        shipper_receiver_form_1: form1,
		    shipper_receiver_form_2: form2,
        insuranceArr: insuranceArr,
        dutyAndTax: dutyTax,
        isDev: false //set true to test in development
      },
    },
  };
  return axios.post(BASE_API, query, { headers }).then((response) => {
    if (!response?.data?.data?.errors || response?.data?.data?.action) {
      return true;
    }
    return false;
  });
};


export const sendBookingThroughAgent = async (jwt_token,customerForm, shipperForm, formInfo,selectedAgent) =>{
  const headers = {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + jwt_token + ""
  }

      let query = {
          "query": "mutation { action(id: $action_id input: $input)}",
          "variables": {
              "action_id": "7512761b97ec4fb3b096725f41089610",
              "input": {
                 "customerForm": customerForm,
                 "shipperReceiverForm":shipperForm,
                 "formInfo":formInfo,
                 "agent": selectedAgent,
                 "isDev": false //set true to test in development
              }
          }
      }

      return axios.post(BASE_API, (query), { headers }).then(response => {
          if (response?.data?.data?.action){
              return true
          }
          return false
      })
}

export const sendNewSignUpRequest = async (jwt_token,form1,form2,bookform,bookingDatacharges) =>{
  const headers = {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + jwt_token + ""
  }

      let query = {
          "query": "mutation { action(id: $action_id input: $input)}",
          "variables": {
             "action_id": "a65a99e584c746bf8134f707d3ed435c",
              "input": {
                "bookform": bookform,
                "bookingDatacharges": bookingDatacharges,
                "signUpForm1": form1,
                "signUpForm2": form2,
                "isDev": false, //set true to test in development
              }
          }
      }
      return axios.post(BASE_API, (query), { headers }).then(response => {
        if (response?.data?.data?.action?.results){
              return [true, response?.data?.data?.action.results]
          }
          return false
      })
}

export const sendSaveQuoteData = async (
  jwt_token,
  quoteObject,
  dischargeObject
) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };
  let query = {
    query: "mutation { action(id: $action_id input: $input)}",
    variables: {
      action_id: "40a8f19a567c44238817da4417b25a84",
      input: {
        discountID: dischargeObject?.discountID,
        save_quote: quoteObject,
        delivery_section_charges: dischargeObject?.delivery_section_charges,
        delivery_section: dischargeObject?.delivery_section,
        port_origin_section: dischargeObject?.port_origin_section,
        pickup_section: dischargeObject?.pickup_section,
        ers_section: dischargeObject?.ers_section,
        port_discharge_section: dischargeObject?.port_discharge_section,
        pickup_section_charges: dischargeObject?.pickup_section_charges,
      },
    },
  };

  return axios.post(BASE_API, query, { headers }).then((response) => {
    if (response?.data?.data?.action?.results) {
      return true;
    }
    return false;
  });
};

export const sendActivityData = async (jwt_token, activityData) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };
  let query = {
    query: "mutation { action(id: $action_id input: $input)}",
    variables: {
      action_id: "ec7473025d96454c8be60ca284d37d7e",
      input: {
        //activityDate: activityData.activityDate,
        from: activityData.from,
        mode: activityData.mode,
        to: activityData.to,
        userId: activityData.user,
        discountId: activityData.discount,
      },
    },
  };

  return axios.post(BASE_API, query, { headers }).then((response) => {
    if (response?.data?.data?.action?.results) {
      return true;
    }
    return false;
  });
};


const executeReCaptcha = async () => {
  try {
      const resCode = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY);
      if (!resCode) {
          throw new Error("reCAPTCHA token is invalid.");
      }
      return resCode;
  } catch (error) {
      console.error("Error during reCAPTCHA execution:", error);
      throw new Error("reCAPTCHA execution failed");
  }
};

export const saveLogActivityData = async (getstate, activityData) => {
  let jwt_token;
  if(activityData.user){
    jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
  }else{
    jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
  }
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };

  const actionId = (activityData.user)
  ? "6cc049db75e74a559f2d1380ce4c5c8f" 
  : "a0e2352833ab45ba9e65437f196c9f24";

  const input = {
    locationFrom: activityData.from,
    mode: activityData.mode,
    locationTo: activityData.to,
    userId: activityData.user,
    discountId: activityData.discount
  };

  // if (!activityData.user) {
  //   try {
  //       input.token = await executeReCaptcha();
  //   } catch (error) {
  //       return [500, error.message];
  //   }
  // }

  const query = {
    query: "mutation { action(id: $action_id input: $input) }",
    variables: {
        action_id: actionId,
        input,
    },
  };
  return axios.post(BASE_API, query, { headers }).then((response) => {
    if (response?.data?.data?.action?.results) {
      return true;
    }
    return false;
  });
};

export function searchPOs(jwt_token, searchText) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };
  const query = `{
        allPurchaseOrder(where: {orderNumbers: {matches: "${searchText}"}}) {
          results {
            orderNumbers
            id
            styleNo
          }
          totalCount
        }
      }`;

  return axios.post(BASE_API, { query }, { headers }).then((result) => {
    if (result?.data?.data?.allPurchaseOrder.results === undefined) {
      return [];
    }

    let resultPO = result?.data?.data?.allPurchaseOrder.results;
    if (resultPO) {
      return resultPO;
    } else {
      return [];
    }
  });
}

export function getPoNumberBySearch(jwt_token) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };
  let query = `{allBooking
            {results
             {  
                id
                posText
                pos{
                    id
                    orderNumbers
                }
                styleNumbers
             }
            }
          }`;

  return axios.post(BASE_API, { query }, { headers }).then((result) => {
    let allPurchaseOrders =
        result?.data &&
        result?.data?.data &&
        result?.data?.data?.allBooking &&
        result.data.data.allBooking.results
          ? result.data.data.allBooking.results
          : [],
      allPoNumber = [];

    allPurchaseOrders.forEach((tempPurchaseOrder) => {
      if (
        tempPurchaseOrder &&
        tempPurchaseOrder.posText &&
        tempPurchaseOrder.pos.length > 0 &&
        !Object.keys(allPoNumber)
          .map((data) => allPoNumber[data].orderNumbers)
          .includes(tempPurchaseOrder.posText)
      ) {
        allPoNumber.push({
          orderNumbers: tempPurchaseOrder.pos[0].orderNumbers,
          id: tempPurchaseOrder.pos[0].id,
          styleNumber: tempPurchaseOrder.styleNumbers,
        });
      }
    });
    return allPoNumber;
  });
}

export function addPurchaseOrder(jwt_token, payload) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };

  let query = {
    query: "mutation { action(id: $action_id input: $input)}",
    variables: {
      action_id: "8be86a3553094977ae45fba8f9f32b92",
      input: {
        payload: payload,
      },
    },
  };

  return axios
    .post(BASE_API, JSON.stringify(query), { headers })
    .then((result) => {
      if (result?.data?.data?.action?.results?.id) {
        return [true, result.data.data.action.results.id];
      }

      return [false];
    });
}

export const getDiscount = async (queryParams, getstate) => {
  const discountCode = queryParams.discount
  const isUserPresent = queryParams.user
  let jwt_token;
  if(isUserPresent){
    jwt_token = queryParams.token;
    //console.log("web user: ",jwt_token)
  }else{
    jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
    //console.log("public user: ",jwt_token)
  }

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };
  const actionId = isUserPresent 
  ? "9ea88a18e52a4a39a4e4a4c4cfe28c03" 
  : "c2fb93ea05e746c38ec694c3e5269316";

  const input = {
    "discountCode": discountCode
  };

  const query = {
    query: "mutation { action(id: $action_id input: $input) }",
    variables: {
        action_id: actionId,
        input,
    },
  };


return axios.post(BASE_API,  query , { headers }).then((result) => {
    const actionData = result.data?.data?.action;
    if (actionData) {
      const responseData = actionData.results || [];
      return [200, responseData];
    }

    return [403, []];
  });
};

export const getAgentProfilesData = async (isUserPresent, getstate) =>{
  let jwt_token;
  if(isUserPresent){
    jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
  }else{
    jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
  }
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };

  const actionId = (isUserPresent)
  ? "f137ba3d2b764bbeb264402771765928" 
  : "dc114ea2a2134cdd960895c950f2c412";

  const query = {
    query: "mutation { action(id: $action_id input: $input) }",
    variables: {
        action_id: actionId,
        input:""
    },
  };

  return axios
    .post(BASE_API, JSON.stringify(query), { headers })
    .then((result) => {
      if (result?.data?.data?.action?.results) {
        return [true, result.data.data.action.results];
      }
      return [false];
  });
}

export const getHSCode = async (payload, getstate, dispatch) =>{
  const isUserPresent =  getstate()?.route?.USER_DETAILS?.webuser?.userid != null

  let jwt_token;
  if(isUserPresent){
    jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
  }else{
    jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
  }

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };
  const actionId = isUserPresent 
  ? "26197fa8b7c048f58e799c029e4cedde"
  : "9299486a3344424aa20b0a5e3ec2ce48"

  const input = {
    "payload": payload
  }

  const query = {
    query: "mutation { action(id: $action_id input: $input) }",
    variables: {
        action_id: actionId,
        input,
    },
  };
   
  return axios.post(BASE_API, (query), { headers }).then(response => {
    if (response?.data?.data?.action?.results){
      return [true, response?.data?.data?.action?.results]
    }else if(response?.data?.data?.errors && response.data.data.errors.length > 0){
      const error = response.data.data.errors[0];  // Get the first error
      const errorMessage = error.message;  // Extract the error message
      const errorCode = error.extensions.statusCode;
      dispatch(updateErrorAndLoading(`${errorCode} : ${errorMessage}`, undefined));
    }
    return false

  })
}


export const getDutyAndTaxFromSimplyDuty = async (payload, getstate, dispatch) =>{
  const isUserPresent =  getstate()?.route?.USER_DETAILS?.webuser?.userid != null

  let jwt_token;
  if(isUserPresent){
    jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
  }else{
    jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
  }

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };
  const actionId = isUserPresent 
  ? "5ff3c5e1c01949378f1a91f53a8f5996"
  : "d0712405ee6d4b0289d6b44d99056ae4";

  const input = {
    "payload": payload
  }

  const query = {
    query: "mutation { action(id: $action_id input: $input) }",
    variables: {
        action_id: actionId,
        input,
    },
  };
   
  return axios.post(BASE_API, (query), { headers }).then(response => {
      if (response?.data?.data?.action?.results){
        return [true, response?.data?.data?.action?.results]
      }else if(response?.data?.data?.errors && response.data.data.errors.length > 0){
        const error = response.data.data.errors[0];  // Get the first error
        const errorMessage = error.message;  // Extract the error message
        const errorCode = error.extensions.statusCode; //
        dispatch(updateErrorAndLoading(`${errorCode} : ${errorMessage}`, undefined));
      }
      return false

  })
}


export const getSelectedCustomBroker = async (jwt_token, userId) =>{
  const headers = {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + jwt_token + ""
  }

  let query = `{
  allCompany(
      where: {
          id: { eq: ${userId}}
      }
  ) {
      results {
          id
          companyName
          customBroker{
              id
              companyName
          }
      }
      totalCount
  }
}`

return axios.post(BASE_API, { query }, { headers }).then(result => {
  if (result.data.data && result.data.data.allCompany) {
      const responseData = result.data && result.data.data && result.data.data.allCompany.results ? result.data.data.allCompany.results : []
      return [200, responseData];
  }
  return [403,[]]
})
}



export const getAllCustomBroker = async (jwt_token) =>{
  const headers = {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + jwt_token + ""
  }

  let query = `{
  allCompany(
      where: {
          isCustomBroker: { eq: true }
          companyName: { regex: "CB" }
      }
  ) {
      results {
          id
          companyName
      }
      totalCount
  }
}`


return axios.post(BASE_API, { query }, { headers }).then(result => {
  if (result.data.data && result.data.data.allCompany) {
      const responseData = result.data && result.data.data && result.data.data.allCompany.results ? result.data.data.allCompany.results : []
      return [200, responseData];
  }
  return [403,[]]
})
}

export function getInsuranceAPItoken(jwt_token, isUserPresent) {

  const headers = {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + jwt_token + ""
  }
  
  const actionId = isUserPresent 
  ? "813afe45f26f4076b1459ef9848782cd" 
  : "4e4ad81d06e54ed99a6115b457dc2fd9"; 

  const input = {
    "isDev": false //set true to test in development
  }

  const query = {
    query: "mutation { action(id: $action_id input: $input) }",
    variables: {
        action_id: actionId,
        input
    },
  };

  return axios.post(BASE_API, JSON.stringify(query), { headers }).then(result => {
    if (result?.data?.data?.action?.results) {
          return [true, result.data.data.action.results];
      }
      return [false];
  })
}

export function getCargoInsurance(isUserPresent, insuranceAuthToken, payload, customer, getstate) {
  let jwt_token;
  if(isUserPresent){
    jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
    //console.log("web user: ",jwt_token)
  }else{
    jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
    //console.log("public user: ",jwt_token)
  }

  const headers = {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + jwt_token + ""
  }

  const actionId = isUserPresent 
  ? "3fa41ca362c346a6959d237d39fe169f" 
  : "b25171b4197248368265d3d35af0c9eb";

  const input = {
      "token": insuranceAuthToken,
      "payload": payload,
      "isDev": false //set true to test in development
  };

  if (!isUserPresent) {
      input.customer = customer
  }

  const query = {
    query: "mutation { action(id: $action_id input: $input) }",
    variables: {
        action_id: actionId,
        input,
    },
  };

  return axios.post(BASE_API, JSON.stringify(query), { headers }).then(result => {
      if (result?.data?.data?.action?.results) {
          return [true, result.data.data.action.results];
      }else if(result?.data?.data?.errors) {
        const errMsg = result.data.data.errors[0].message
        console.error(errMsg)
      }
      return [false];
  })
}

export function getCargoInsurancePolicy(isUserPresent, insuranceAuthToken, quoteId, getstate) {
  let jwt_token;
  if(isUserPresent){
    jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
  }else{
    jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
  }

  const headers = {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + jwt_token + ""
  }
  const actionId = isUserPresent 
  ? "db00c91df987431e85ab2b4e3131507e" 
  : "b093c1b947c7405483f54ff00de5578a";

  const input = {
      "token": insuranceAuthToken,
      "quoteId": quoteId,
      "isDev": false //set true to test in development
  };

  const query = {
    query: "mutation { action(id: $action_id input: $input) }",
    variables: {
        action_id: actionId,
        input,
    },
  };

  return axios.post(BASE_API, JSON.stringify(query), { headers }).then(result => {
      if (result?.data?.data?.action?.results) {
          return [true, result.data.data.action.results];
      }else if(result?.data?.data?.errors) {
        const errMsg = result.data.data.errors[0].message
        console.error(errMsg)
      }

      return [false];

  })
}

export function getCommodityList(jwt_token,isUserPresent,insuranceAuthToken) {
  const headers = {
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + jwt_token + ""
  }
    
  const actionId = isUserPresent 
  ? "d1b6ffa9b68640a0b01893e7390a2cbf"
  : "3619852af1c342d59f5620657a9fc77d";

  const input = {
    "token": insuranceAuthToken,
    "isDev": false //set true to test in development
  };

  const query = {
    query: "mutation { action(id: $action_id input: $input) }",
    variables: {
        action_id: actionId,
        input,
    },
  };

  return axios.post(BASE_API, JSON.stringify(query), { headers }).then(result => {
      if (result?.data?.data?.action?.results) {
          return [true, result.data.data.action.results];
      }
      return [false];
  })
}


export const get_commodity_list = async (getstate,dispatch) => {
  const isUserPresent =  getstate()?.route?.USER_DETAILS?.webuser?.userid != null
  let jwt_token
  if(isUserPresent){
    jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
  }else{
    jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
  }

    // Step 1: Get insurance API token
    getInsuranceAPItoken(jwt_token, isUserPresent)
        .then(([success, results]) => {
            if (success) {
                // Step 2: Use the token to get the commodity list
                const insuranceAuthToken = "Bearer "+results; // Adjust based on the actual token format
                dispatch({
                  type: INSURANCE_AUTH_TOKEN,
                  payload: insuranceAuthToken,
              });
                return getCommodityList(jwt_token, isUserPresent, insuranceAuthToken);
            } else {
                throw new Error('Failed to fetch insurance API token');
            }
        })

        .then(([success, commodityResults]) => {
            if (success) {
                //console.log("\ncommodityResults: ",commodityResults)
                dispatch({
                  type: SET_COMMODITY_CATEGORY_LIST,
                  payload: commodityResults,
              });
                return success
            } else {
                throw new Error('Failed to fetch commodity list');
            }
        })
        .catch(error => {
          console.error(error)
        });
}

export const getScheduleData = async (id, isUserPresent, getstate) => {
  let jwt_token;
  if(isUserPresent){
    jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
    //console.log("web user: ",jwt_token)
  }else{
    jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
    //console.log("public user: ",jwt_token)
  }

  const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + jwt_token + "",
    };


  const actionId = isUserPresent 
  ? "c6c6b0968ead40e3bee24ebbff6589d2" 
  : "2709b645e2c346b091e097b8787aab6c";

  const input = {
    "charge_type_id": id
  };
  // if (!isUserPresent) {
  //   try {
  //       input.token = await executeReCaptcha();
  //   } catch (error) {
  //       return [500, error.message];
  //   }
  // }

  const query = {
    query: "mutation { action(id: $action_id input: $input) }",
    variables: {
        action_id: actionId,
        input,
    },
  };

  return axios.post(BASE_API,  query , { headers }).then((result) => {
    if (result.data.data && result.data.data.action.results) {
      const responseData =
      result.data &&
      result.data.data &&
      result.data.data.action.results
        ? result.data.data.action.results?.[0]
        : [];

      let scheduleData = [];
      if (responseData) {
          //const scheduleDataResult = responseData.buying_rate ? responseData.schedules : responseData?.buying_linked_rate?.schedules;
          //console.log("scheduleDataResult", scheduleDataResult);
          const scheduleDataResult =  responseData?.schedules
          if(scheduleDataResult && scheduleDataResult.length > 0){
            scheduleData = scheduleDataResult
          }
          return [200, scheduleData];
      } else {
          return [403, []];
      }
  }
  return [403, []];
});
}

// //This action and function was cretaed as part of Line scape API integration..need to be deleted
// export const updatePortTransitTimeChargeType = async (id, averageTime, isUserPresent, getstate) => {
//   let jwt_token;
//   if(isUserPresent){
//     jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
//     //console.log("web user: ",jwt_token)
//   }else{
//     jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
//     //console.log("public user: ",jwt_token)
//   }
//   const headers = {
//     "Content-Type": "application/json",
//     Authorization: "Bearer " + jwt_token + "",
//   };

//   const actionId = isUserPresent 
//   ? "ba8c02ac97cc4ac4817d841d9ee577cb" 
//   : "b4fb7ebcb6ff4488a635d4ee26530244";

//   const input = {
//     charge_type_id: id,
//     port_transit_time: Number(averageTime)
//   };

//   // if (!isUserPresent) {
//   //   try {
//   //       input.token = await executeReCaptcha();
//   //   } catch (error) {
//   //       return [500, error.message];
//   //   }
//   // }

//   const query = {
//   query: "mutation { action(id: $action_id input: $input) }",
//   variables: {
//       action_id: actionId,
//       input,
//   },
//   };

//   return axios.post(BASE_API, query, { headers }).then((result) => {
//   if (result?.data?.data?.action?.results) {
//       const responseData = result?.data?.data?.action?.results || []
//       if(responseData){
//         return [200, responseData];
//       }
//     }
//     return [403, []];
//   });
// }

// //Part of Line scape API integration.. need to be deleted
// export const getScheduleDataFromAPI = async (data, isUserPresent, getstate) => {
//   let jwt_token;
//   if(isUserPresent){
//     jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
//     //console.log("web user: ",jwt_token)
//   }else{
//     jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
//     //console.log("public user: ",jwt_token)
//   }
//   const headers = {
//       "Content-Type": "application/json",
//       Authorization: "Bearer " + jwt_token + "",
//     };

//   const actionId = isUserPresent 
//   ? "4e435fac095746e58e3ad1c4068d0233" 
//   : "159252b19d25499ca0ede5ee97bb372b";

//   const input = {
//     carrier_code: data?.carrier_code,
//     destination_code: data?.destination_code,
//     origin_code: data?.origin_code,
// };

// //   if (!isUserPresent) {
// //     try {
// //         input.token = await executeReCaptcha();
// //     } catch (error) {
// //         return [500, error.message];
// //     }
// // }

// const query = {
//   query: "mutation { action(id: $action_id input: $input) }",
//   variables: {
//       action_id: actionId,
//       input,
//   },
// };

// return axios.post(BASE_API, query, { headers }).then((result) => {
//   if (result?.data?.data?.action?.results) {
//       const responseData = result?.data?.data?.action?.results?.items
//       if(responseData && responseData.length > 0){
//          return [200, responseData];
//       }
//     }
//     return [403, []];
// });
// }

// //Part of Line scape API integration.. need to be deleted
// export const sendScheduleDataFromAPI = async (payload, isUserPresent, scheduleData, getstate) => {
//   let jwt_token;
//   if(isUserPresent){
//     jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
//     //console.log("web user: ",jwt_token)
//   }else{
//     jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
//     //console.log("public user: ",jwt_token)
//   }
//   const headers = {
//       "Content-Type": "application/json",
//       Authorization: "Bearer " + jwt_token + "",
//     };


//   const actionId = isUserPresent 
//   ? "ff8a5c07c61645a18da438ef594ae284" 
//   : "bfefb4bc449f4583a8900228672788f5";

//   const input = {
//     "payload": payload,
//     "scheduleData": scheduleData
//   };

//   // if (!isUserPresent) {
//   //   try {
//   //       input.token = await executeReCaptcha();
//   //   } catch (error) {
//   //       return [500, error.message];
//   //   }
//   // }

//   const query = {
//     query: "mutation { action(id: $action_id input: $input) }",
//     variables: {
//         action_id: actionId,
//         input,
//     },
//   };

//   return axios.post(BASE_API,  query, { headers }).then((result) => {
//   if (result?.data?.data?.action?.results) {
//       const responseData = result?.data?.data?.action?.results || []
//       if(responseData){
//          return [200, responseData];
//       }
//     }
//     return [403, []];

// });
// }

export const sendQuoteRequest = async (customerInfo, getstate ) => {
   const origin = getstate()?.route?.savedFormParams?.pickup?.selectedPort
   const destination =  getstate()?.route?.savedFormParams?.delivery?.selectedPort
   const type =  getstate()?.route?.savedFormParams?.type

   const isUserPresent =  getstate()?.route?.USER_DETAILS?.webuser?.userid != null

   let jwt_token;
   if(isUserPresent){
     jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
   }else{
     jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
   }
 
   const headers = {
     "Content-Type": "application/json",
     Authorization: "Bearer " + jwt_token + "",
   };
   const actionId = isUserPresent 
   ? "342762728fd2447cb66c0ff9ef064fd6"
   : "ea7c78533793444a850b274522f9d33e"
 
   const input = {
     "customerFormInfo": customerInfo,
     "origin": origin,
     "destination": destination,
     "type": type
   }
 
   const query = {
     query: "mutation { action(id: $action_id input: $input) }",
     variables: {
         action_id: actionId,
         input,
     },
   };
  
   return axios.post(BASE_API, (query), { headers }).then(result => {
     if (!result?.data?.data?.errors && result?.data?.data?.action){
        return {
          status: true,
          data: result?.data?.data?.action?.results,
        };
     }
     return {
      status: false,
      error: "error from bb"
    };
   })

}

/**
 * @function
 * @name Make_Database_Call
 *@description will make call to database via post
 * @return return response from API
 *
 */
const Make_Database_Call = async (jwt_token, query) => {
  if (LINK) {
    return await axios
      .post(
        BASE_API,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt_token + "",
          },
        }
      )
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          return {
            status: response.status,
            data: response.data,
          };
        } else {
          return {
            status: response.status,
            error: response.statusText,
          };
        }
      });
  } else {
    return await axios
      .post(BASE_API, {
        headers: {
          Authorization: "Bearer " + jwt_token + "",
        },
        query,
        token: jwt_token,
      })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          return {
            status: response.status,
            data: response.data,
          };
        } else {
          return {
            status: response.status,
            error: response.statusText,
          };
        }
      });
  }
};

/**
 * @function
 * @name separate_data
 * @description  will take origin port and destination port, and map it as per the format of redux store
 * @returns {Redux.Action} Will return object containing port origin and port destination
 */
const separate_data = async (port_from, port_to) => {
  let port_destination = {
    Ports: [],
  };
  let port_origin = {
    Ports: [],
  };
  port_to.forEach((object, index) => {
    port_destination.Ports.push({
      id: object.id,
      Name: object.company_name,
      Country: object.in_country.company_name,
      CountryId: object.in_country.id,
      linkedPort: object?.linked_port,
      portLinked: object?.port_linked,
      portCode: object?.scac_code,
    });
  });

  port_from.forEach((object, index) => {
    port_origin.Ports.push({
      id: object.id,
      Name: object.company_name,
      Country: object.in_country.company_name,
      CountryId: object.in_country.id,
      linkedPort: object?.linked_port,
      portLinked: object?.port_linked,
      portCode: object?.scac_code,
    });
  });

  return {
    port_origin: port_origin,
    port_destination: port_destination,
  };
};

const get_all_ports_data = async (jwt_token, isUserPresent, take, skip) =>{
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': "Bearer " + jwt_token + ""
  }

  const actionId = isUserPresent 
    ? "2cc7669560b9427682bc9307fe1c6f76" 
    : "365378f76fb04bfebe5b4d35db53ed4e";

  const input = {
      skip,
      take,
  };

  const query = {
      query: "mutation { action(id: $action_id input: $input) }",
      variables: {
          action_id: actionId,
          input,
      },
  };

  return axios.post(BASE_API, JSON.stringify(query), { headers }).then(response => {
    if (response.status === 200 || response.status === 201) {
      if (response?.data?.data?.action?.results) {
          return [200, response.data.data.action.results]
      }
    }
    return [403,[]]
  })
}



export const get_all_ports_from_db = async (getstate) => {
  const isUserDetailsValid = () => {
    const userDetails = getstate().route.USER_DETAILS;
    return userDetails !== null && userDetails !== undefined && 
           (typeof userDetails === 'object' ? Object.keys(userDetails).length > 0 : userDetails.trim().length > 0);
  };

  const isUserPresent = isUserDetailsValid();
 
  let jwt_token;
  if(isUserPresent){
    jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
  }else{
    jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
  }
  
  if (jwt_token !== "" || jwt_token !== undefined) {
      let final_ports_from_bettyblocks = []
      let skip = 0
      let take = 100
      let iterator = 1
      let response;
      for (let pos = 0; pos < iterator; pos++) {
        response = await get_all_ports_data(jwt_token,isUserPresent,take,skip);
        if ( response && response?.[0] === 200 ) {
          if (response[1] && response[1].length > 1) {
            response[1].forEach((object, index) => {
                  final_ports_from_bettyblocks.push(object)
              })
              iterator = iterator + 1
              if (skip === 0) {
                  skip = 100
              } else {
                  skip = skip + 100
              }
          }
          // else{
          //   console.log("Port data loaded")
          // }
        } else {
          console.log("IN Graphql Error")
        }
      }

      let port_from = []
      let port_to = []
      final_ports_from_bettyblocks.forEach((object, index) => {
          if (object.in_country != null) {
              port_to.push(object)
              port_from.push(object)
          }
      })
      let final_ports = await separate_data(port_from, port_to)
      return {
          "status": "200",
          "response": final_ports
      }
  } else {
      return {
          "status": "404",
          "error": "No JWT found"
      }
  }
}

/**
 * @function
 * @name all_response_validation
 * @description will check the response from api till grapqhl, return true, if all success, else return false if there is any error
 * @return true if sucess, else false with fail message
 * @param response
 * @return {Promise<{bool: boolean, error}>}
 */
export const all_response_validation = async (response, property) => {
  if (response.status === 200 || response.status === 201) {
    // when grapqhl response with data
    if (response.data.data.hasOwnProperty(property)) {
      return {
        bool: true,
        response: response,
      };
    }
    // grapqhl ql error
    else {
      return {
        status: "520",
        bool: false,
        error: "Token Expire, Sign-out and Sign-in again",
      };
    }
  }
  // when response does not success
  else {
    return {
      status: response.status,
      bool: false,
      error: response.error,
    };
  }
};

export const round_number_to_next_digit = async (rates) => {
  if (rates.rate_type === "FCL") {
    rates._20price = Math.round(rates._20price);
    rates._40hqPrice = Math.round(rates._40hqPrice);
    rates._40price = Math.round(rates._40price);
    rates._45price = Math.round(rates._45price);
  } else {
    rates.unit_cost = Math.round(rates?.unit_cost);
  }

  return rates;
};

export const For_FLat_Increase_Or_Decrease = async (rates, flat_price) => {
  if (rates.rate_type === "FCL") {
    rates._20price = (rates._20price + flat_price).toFixed(2);
    rates._40hqPrice = (rates._40hqPrice + flat_price).toFixed(2);
    rates._40price = (rates._40price + flat_price).toFixed(2);
    rates._45price = (rates._45price + flat_price).toFixed(2);

    rates = await round_number_to_next_digit(rates);

    return rates;
  } else {
    rates.unit_cost = (rates?.unit_cost + flat_price).toFixed(2);
    rates = await round_number_to_next_digit(rates);

    return rates;
  }
};

export const Add_Addons_Profit = async (rates, routes_profit) => {
  if (rates.rate_type === "FCL") {
    rates._20price = (rates._20price * routes_profit).toFixed(2);
    rates._40hqPrice = (rates._40hqPrice * routes_profit).toFixed(2);
    rates._40price = (rates._40price * routes_profit).toFixed(2);
    rates._45price = (rates._45price * routes_profit).toFixed(2);
    rates = await round_number_to_next_digit(rates);

    return rates;
  } else {
    rates.unit_cost = (rates?.unit_cost * routes_profit).toFixed(2);
    rates = await round_number_to_next_digit(rates);

    return rates;
  }
};

/**
 * @function
 * @name add_global_profit_on_buying_rates
 * @param rates -> to get the current rate,
 * @param profitPercentageAddon
 * @description will return the rates based multiplying with global profit percent
 * @return return object, containing rates with global profit
 */
export const add_routes_profit = async (
  rates,
  getstate,
  profitPercentageAddon
) => {
  let routes_profit = 0;
  if (profitPercentageAddon !== undefined && profitPercentageAddon !== null) {
    routes_profit = Number(profitPercentageAddon) + 1;
    rates = await Add_Addons_Profit(rates, routes_profit);
    if (getstate().route.USER_DETAILS !== undefined) {
      if (
        getstate().route.USER_DETAILS.defaultFclDiscount !== null &&
        getstate().route.USER_DETAILS.defaultFclDiscount > 1 &&
        rates.rate_type === "FCL"
      ) {
        console.log("IN FCL DISCOUNT");
        let flat_increase = parseFloat(
          getstate().route.USER_DETAILS.defaultFclDiscount
        );
        if (flat_increase > 0) {
          let negative_num = flat_increase * -1;
          rates = await For_FLat_Increase_Or_Decrease(rates, negative_num);
        }
      }
      if (
        getstate().route.USER_DETAILS.defaultLclDiscount !== null &&
        getstate().route.USER_DETAILS.defaultLclDiscount > 1 &&
        rates.rate_type === "LCL"
      ) {
        console.log("IN LCL DISCOUNT");
        let flat_increase = parseFloat(
          getstate().route.USER_DETAILS.defaultLclDiscount
        );
        if (flat_increase > 0) {
          let negative_num = flat_increase * -1;
          rates = await For_FLat_Increase_Or_Decrease(rates, negative_num);
        }
      }
    }
  }

  routes_profit = Number(rates?.route?.profit_perfect || 0) + 1;

  rates = await Add_Addons_Profit(rates, routes_profit);
  return rates;
};

export const add_global_profit_on_buying_rates = async (rates, getstate) => {
  const _20price =  rates["20price"]
  const _40price =  rates["40price"]
  const _40hqPrice =  rates["40hq_price"]
  const _45price = rates["45price"]
  if (rates.rate_type === "FCL") {
    rates._20price = (_20price * GLOBAL_PROFIT_PERCENT).toFixed(2);
    rates._40hqPrice = (_40hqPrice * GLOBAL_PROFIT_PERCENT).toFixed(2);
    rates._40price = (_40price * GLOBAL_PROFIT_PERCENT).toFixed(2);
    rates._45price = (_45price * GLOBAL_PROFIT_PERCENT).toFixed(2);

    if (getstate().route.USER_DETAILS !== undefined) {
      if (getstate().route.USER_DETAILS.profitPercentageAddon !== undefined) {
        let profitPercentageAddon = Number(
          getstate().route.USER_DETAILS.profitPercentageAddon
        );
        await add_routes_profit(rates, getstate, profitPercentageAddon);
      }
    }

    if (
      rates.route !== null &&
      Object.keys(getstate().route.USER_DETAILS).length === 0
    ) {
      if (
        rates?.route?.profit_perfect !== null &&
        (rates?.route?.profit_perfect > 0 || rates?.route?.profit_perfect < 0)
      ) {
        await add_routes_profit(rates, getstate);
      }
    }

    return rates;
  } else {
    rates.unit_cost = (rates?.unit_cost * GLOBAL_PROFIT_PERCENT).toFixed(2);

    if (getstate().route.USER_DETAILS !== undefined) {
      if (getstate().route.USER_DETAILS.profitPercentageAddon !== undefined) {
        let profitPercentageAddon = Number(
          getstate().route.USER_DETAILS.profitPercentageAddon
        );
        await add_routes_profit(rates, getstate, profitPercentageAddon);
      }
    }

    if (
      rates.route !== null &&
      Object.keys(getstate().route.USER_DETAILS).length === 0
    ) {
      if (
        rates.route?.profit_perfect !== null &&
        rates.route?.profit_perfect !== 0
      ) {
        await add_routes_profit(rates, getstate);
      }
    }

    return rates;
  }
};

export const change_lcl_vessel_service = async (rates_object) => {
  if (rates_object.rate_type === "LCL") {
    rates_object.vessel_service = {
      name: "Prime freight service contract",
      // "id": rates_object.carrier.id
      id: 307,
    };
  }

  return rates_object;
};

export const mapping_value_in_FCL_And_LCL = async (
  rates_object,
  query_parameter,
  requestFromClient
) => {
  // vessel service is empty
  if (rates_object.vessel_service === null) {
    rates_object.vessel_service = {
      name: rates_object?.carrier?.company_name,
      id: rates_object?.carrier?.id,
    };
    rates_object = await change_lcl_vessel_service(rates_object);
  } else {
    rates_object = await change_lcl_vessel_service(rates_object);
  }
  // vendor contract is empty

  if (rates_object.vendor_contract === null) {
    rates_object.vendor_contract = {
      name: rates_object?.carrier?.company_name,
      id: rates_object?.carrier?.id,
    };
  }

  //  setting object
  let object = {
    uuid: rates_object?.uuid,
    id: rates_object.id,
    charge_id: rates_object.chargeId,
    charge_type_id: rates_object.chargeTypeId,
    mode: rates_object.mode,
    currency: rates_object.currency,
    buyingRate: rates_object.buying_rate,
    schedulesTransitTime: rates_object?.schedules_transit_time,
    transshipments: rates_object?.transshipments,
    schedules: rates_object?.schedules,
    local_schedule_key: rates_object?.local_schedule_key,
    transitTime: rates_object?.transit_time,
    portTransitTime: rates_object?.port_to_port_transit_time,
    // "transitTime": (rates_object?.schedulesTransitTime ?? rates_object?.transitTime),
    thc_exp: true,
    thc_imp: false,
    fee_exp: false,
    fee_imp: false,
    origin_checked: false,
    freight_checked: true,
    discharge_checked: true,
    origin_checkable: true,
    freight_checkable: false,
    discharge_checkable: false,
    is_estimate: false,
    valid_date_from: rates_object.validity_from,
    valid_date_to: rates_object.validity_to,
    port_of_origin: rates_object?.location_from?.company_name,
    // "port_of_discharge": rates_object.viaPort.companyName,
    port_of_discharge: rates_object.via_port,
    company_link:
      rates_object.carrier.company_website !== undefined
        ? rates_object.carrier.company_website
        : "",
    carrier_scac_code: rates_object.carrier.scac_code,
    company_about: rates_object.carrier.company_about,
    schedule_website_link: rates_object.carrier.schedule_website_link,
    avatar: rates_object.carrier.company_avatar_image.url,  
    description:
    requestFromClient
      ? ( rates_object?.schedules 
        ? `Rates are valid from ${rates_object.validity_from} Till ${rates_object.validity_to}` 
        : `Vessel service-: ${rates_object.vessel_service.name}. Rates are valid from ${rates_object.validity_from} Till ${rates_object.validity_to}`)
      : "Vessel service-: " + rates_object.vessel_service.name + ". Rates are valid from " + rates_object.validity_from + " Till " + rates_object.validity_to,
    ers_checked: true,
    ers_checkable: false,
    ers_location: rates_object?.location_to?.company_name,
    ers_selected_option: 0,
    vessel_Service: rates_object.vessel_service,
    vendor_contract: rates_object.vendor_contract,
    etd_origin: query_parameter.etd_origin,
    updatePickupDeliveryErsLine: {},
    ers_section: [
      {
        name: "Regular Rail Service",
        rate: [["Included", "", "0", false, "0"]],
        currency: "USD",
        multiply: true,
        id: "0",
        fetch_zip_code: false,
        description: "",
      },
      {
        name: "ERS Expedited Rail Service",
        rate: [["EXP1", "Expedite Charge", "200", true, "200", 153]],
        currency: "USD",
        multiply: true,
        id: "1",
        fetch_zip_code: false,
        description:
          "Save up to 3 days of transit time and avoid additional port delays with priority rail service",
      },
    ],
    sealine: rates_object?.carrier?.company_name,
    carrier: rates_object.carrier,
    pickup_checked: false,
    pickup_checkable: true,
    pickup_selected_option: 0,
    pickup_section: [
      {
        name: "Truck",
        currency: "USD",
        description: "Pickup",
        lcl_min_rate: null,
        multiply: true,
        id: "0",
        fetch_zip_code: true,
      },
      {
        name: "Variable Rate",
        rate: "440.00",
        currency: "USD",
        description:
          "Prime Freight will advise of the cartage costs before proceeding with the shipment",
        lcl_min_rate: null,
        multiply: true,
        show_variable_rate: true,
        id: "2",
      },
    ],
    delivery_checked: false,
    delivery_checkable: false,
    delivery_selected_option: 0,

    // port of origin
    port_fees_from: [
      [
        "Variable Charge",
        "Variable Charge: Prime Freight will advise of the final origin charges after booking",
        "",
        false,
        "",
      ],
    ],
    // discharge
    port_fees_to: [
      [
        "LLEO",
        "Legal Liability, Errors and Omissions Insurance",
        "5",
        false,
        "5",
        284,
      ],
      ["HBL", "HBL Fee", "25", false, "25", 431],
      ["ACI", "ACI", "30", false, "30.00", 543],
    ],
    destination_extra_charges: [],
  };

  // when destination and discharge is same
  if (rates_object.location_to.id === rates_object.via_port.id) {
    object.ers_checked = false;
    object.ers_checkable = false;
  }

  if (rates_object.location_from.id === 653441) {
    if (rates_object.rate_type === "FCL") {
      object.port_fees_to.push([
        "OVERSEAS",
        "Overseas Terminal & Handling",
        "2.50",
        false,
        "2.50",
        527,
      ]);
    } else {
      object.port_fees_to.push([
        "OVERSEAS",
        "Overseas Terminal & Handling",
        "2.50",
        true,
        "2.50",
        527,
      ]);
    }
  }

  return object;
};

export const Normalize_Data = async (rates_object) => {
  let new_object = {
    id: rates_object.id,
    uuid: rates_object?.uuid,
    local_schedule_key: rates_object?.local_schedule_key,
    schedules: rates_object?.schedules,
    rate_type: rates_object.chargetypes.rate_type,
    _20price: rates_object.price20,
    _40price: rates_object.price40,
    _40hqPrice: rates_object.price40hq,
    currency: rates_object.chargetypes.currency,
    carrier: rates_object.chargetypes.carrier,
    location_from: rates_object.chargetypes.location_from,
    location_to: rates_object.chargetypes.location_to,
    vendor_contract: rates_object.chargetypes.vendor_contract,
    vessel_service: rates_object.chargetypes.vessel_service,
    via_port: rates_object.chargetypes.via_port,
    validity_from: rates_object.chargetypes.validity_from,
    validity_to: rates_object.chargetypes.validity_to,
    chargeId: rates_object.id,
    chargeTypeId: rates_object.chargetypes.id,
    mode: rates_object.chargetypes.mode,
    buying_rate: rates_object.buying_rate,
    transit_time: rates_object?.chargetypes?.transit_time,
    portTransitTime: rates_object?.chargetypes?.port_to_port_transit_time,
    //"transitTime": Number(rates_object?.schedulesTransitTime ?? rates_object?.transitTime),
    schedules_transit_time: rates_object?.chargetypes?.schedules_transit_time,
  };

  if (rates_object.chargetypes.rate_type === "LCL") {
    new_object.unit_cost = Number(rates_object?.unit_cost);
  }
  return new_object;
};

export const Normalize_Data_Charge_Types = async (rates_object) => {
  let new_object = {
    chargeId: null,
    chargeTypeId: rates_object.id,
    ...rates_object,
  };
  return new_object;
};

/**
 * @function
 * @name add_global_profit_on_buying_rates
 * @description will return the rates based multiplying with global profit percent
 * @return return object, containing rates with global profit
 * @param rates_object current iteration of buying rate
 * @param rates_from_bb object for final store
 * @param pos
 * @param query_parameter
 * @param quote_check
 */

export const setting_JSON_For_Redux_Store = async (
  rates_object,
  rates_from_bb,
  pos,
  query_parameter,
  requestFromClient = false,
  quote_check,
) => {
  if (rates_object.rate_type === "FCL") {
    rates_from_bb.rates.fcl[pos] = await mapping_value_in_FCL_And_LCL(
      rates_object,
      query_parameter,
      requestFromClient
    );
    rates_from_bb.rates.fcl[pos]["20st"] = rates_object._20price;
    rates_from_bb.rates.fcl[pos]["40st"] = rates_object._40price;
    rates_from_bb.rates.fcl[pos]["40hq"] = rates_object._40hqPrice;
    rates_from_bb.rates.fcl[pos]["45hq"] = rates_object._45price;
  } else {
    rates_from_bb.rates.lcl[pos] = await mapping_value_in_FCL_And_LCL(
      rates_object,
      query_parameter,
      requestFromClient
    );
    rates_from_bb.rates.lcl[pos].sealine = "Prime Freight Console";
    rates_from_bb.rates.lcl[pos].avatar =
      "https://assets.bettyblocks.com/da93364a2-9d0e141d60e3426481b539f85aaaf6b2/643552/high-resolution-dark.png";
    rates_from_bb.rates.lcl[pos]["rate"] = Number(rates_object?.unit_cost);
  }
  // to check if quote_ check is to door or not
  // to check if its montreal
  if (rates_object.location_to.company_name.includes("Montreal")) {
    if (rates_object.rate_type === "FCL") {
      if (quote_check !== undefined) {
        if (quote_check.to_door) {
          rates_from_bb.rates.fcl[pos]["20st"] =
            rates_from_bb.rates.fcl[pos]["20st"] - FCL_DELIVERY_FEE;
          rates_from_bb.rates.fcl[pos]["40st"] =
            rates_from_bb.rates.fcl[pos]["40st"] - FCL_DELIVERY_FEE;
          rates_from_bb.rates.fcl[pos]["40hq"] =
            rates_from_bb.rates.fcl[pos]["40hq"] - FCL_DELIVERY_FEE;
          rates_from_bb.rates.fcl[pos]["45hq"] =
            rates_from_bb.rates.fcl[pos]["45hq"] - FCL_DELIVERY_FEE;
          rates_from_bb.rates.fcl[pos].delivery_checked = true;
        }
        rates_from_bb.rates.fcl[pos].delivery_checkable = true;
        rates_from_bb.rates.fcl[pos].delivery_section = [
          {
            name: "Alredy included",
            rate: [
              [
                "FCL",
                "FCL Delivery.",
                FCL_DELIVERY_FEE,
                false,
                FCL_DELIVERY_FEE,
                18,
              ],
            ],
            currency: "USD",
            description:
              "Delivery within " +
              rates_object.location_to.company_name +
              " limits",
            lcl_min_rate: null,
            multiply: true,
            id: "0",
            fetch_zip_code: false,
          },
        ];
      } else {
        rates_from_bb.rates.fcl[pos].delivery_checkable = true;
        rates_from_bb.rates.fcl[pos].delivery_section = [
          {
            name: "To Door Delivery",
            rate: [
              [
                "FCL",
                "FCL Delivery.",
                FCL_DELIVERY_FEE,
                false,
                FCL_DELIVERY_FEE,
                18,
              ],
            ],
            currency: "USD",
            description:
              "Delivery within " +
              rates_object.location_to.company_name +
              " limits",
            lcl_min_rate: null,
            multiply: true,
            id: "0",
            fetch_zip_code: false,
          },
          {
            name: "Variable Rate",
            rate: "440.00",
            currency: "USD",
            description:
              "Prime Freight will advise of the cartage costs before proceeding with the shipment",
            lcl_min_rate: null,
            multiply: true,
            show_variable_rate: true,
            id: "2",
          },
        ];
      }
    } else {
      if (quote_check !== undefined) {
        if (quote_check.to_door) {
          rates_from_bb.rates.lcl[pos]["rate"] =
            rates_from_bb.rates.lcl[pos]["rate"] - LCL_DELIVERY_FEE;
          rates_from_bb.rates.lcl[pos].delivery_checked = true;
        }
        rates_from_bb.rates.lcl[pos].delivery_checkable = true;
        rates_from_bb.rates.lcl[pos].delivery_section = [
          {
            name: "Alredy included",
            rate: [
              [
                "LCL",
                "LCL Delivery.",
                LCL_DELIVERY_FEE,
                false,
                LCL_DELIVERY_FEE,
                9,
              ],
            ],
            currency: "USD",
            description:
              "Delivery within " +
              rates_object.location_to.company_name +
              " limits",
            lcl_min_rate: null,
            multiply: true,
            id: "0",
            fetch_zip_code: false,
          },
        ];
      } else {
        rates_from_bb.rates.lcl[pos].delivery_checkable = true;
        rates_from_bb.rates.lcl[pos].delivery_section = [
          {
            name: "To Door Delivery",
            rate: [
              [
                "LCL",
                "LCL Delivery.",
                LCL_DELIVERY_FEE,
                true,
                LCL_DELIVERY_FEE,
                9,
              ],
            ],
            currency: "USD",
            description:
              "Delivery within " +
              rates_object.location_to.company_name +
              " limits",
            lcl_min_rate: null,
            multiply: true,
            id: "0",
            fetch_zip_code: false,
          },
          {
            name: "Variable Rate",
            rate: "440.00",
            currency: "USD",
            description:
              "Prime Freight will advise of the cartage costs before proceeding with the shipment",
            lcl_min_rate: null,
            multiply: true,
            show_variable_rate: true,
            id: "2",
          },
        ];
      }
    }
  }
  return rates_from_bb;
};

export const Set_Query_For_Client = async (query, query_parameter, Type) => {
  query += "{\n";
  // To get the client detail from Database
  if (Type === "DETAILS") {
    query += "meWebuser\n";
    query += "{\n";
    query += "id\n";
    query += "email\n";
    query += "firstName\n";
    query += "lastName\n";
    query += "entity";
    query += "{";
    query += "id\n";
    query += "companyName\n";
    query += "minimumCbm\n";
    query +=
      "profitPercentageAddon\n   " +
      " defaultFclDiscount\n" +
      "      defaultLclDiscount\n" +
      "      charges_Reductions{\n" +
      "        id\n" +
      "        forAll\n" +
      "        price_20\n" +
      "        price_40\n" +
      "        price_45\n" +
      "        unitCost\n" +
      "      }";
    query += "}";
    query += "}";
  }
  query += "}";

  return query;
};

export const Set_Query_For_Client_Action = async (getstate, query_parameter, Type) => {
    const locationFrom = query_parameter?.location_from?.map((port) => port.id)
    const locationTo = query_parameter?.location_to?.map((port) => port.id)
    const webuser = getstate().route?.USER_DETAILS?.webuser

    let jwt_token;
    if(webuser && webuser.userid){
      jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
    }else{
      jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
    }
 
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + jwt_token + "",
    };
  
    const actionId = (webuser && webuser.userid)
    ? "fb04ffeb49e94b2791ce57f8b8e28674"
    : "84680382e36a4b5dbb7ef1181a1f7cc6";
  
    const input = {
      "etdOrigin": query_parameter.etd_origin,
      "locationFrom": locationFrom,
      "locationTo": locationTo,
      "mode": query_parameter.mode,
      "rateType": query_parameter.rate_type,
      "skip": query_parameter.skip,
      "take": query_parameter.take,
    };
  
    const query = {
      query: "mutation { action(id: $action_id input: $input) }",
      variables: {
          action_id: actionId,
          input,
      },
    };
 
   return axios.post(BASE_API,  query, { headers }).then((result) => {
    if (result?.data?.data?.action?.results) {
        const responseData = result?.data?.data?.action?.results || []
        if(responseData){
           return [200, responseData];
        }
      }
      return [403, []];
  });
   
};


export const get_chargetypes_for_air_and_Sea = async (query_parameter, getstate) =>{
  const locationFrom = query_parameter?.location_from?.map((port) => port.id)
  const locationTo = query_parameter?.location_to?.map((port) => port.id)
  const webuser = getstate().route?.USER_DETAILS?.webuser

  let jwt_token;
  if(webuser && webuser.userid){
    jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
  }else{
    jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
  }
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + jwt_token + "",
  };

  const actionId = (webuser && webuser.userid)
  ? "09a39dbeca254d25a28134536c0bc767"
  : "8c814c9bd272401f9a6e142e6f760c4e";

  const input = {
    "etdOrigin": query_parameter.etd_origin,
    "locationFrom": locationFrom,
    "locationTo": locationTo,
    "mode": query_parameter.mode,
    "rateType": query_parameter.rate_type,
    "skip": query_parameter.skip,
    "take": query_parameter.take,
  };

  const query = {
    query: "mutation { action(id: $action_id input: $input) }",
    variables: {
        action_id: actionId,
        input,
    },
  };
 return axios.post(BASE_API,  query, { headers }).then((result) => {
  if (result?.data?.data?.action?.results) {
      const responseData = result?.data?.data?.action?.results || []
      if(responseData){
         return [200, responseData];
      }
    }
    return [403, []];
});

}

/**
 * @function
 * @name de_duplicates_rates
 * @description it will de-duplicate rates based on rates, location_from,location_to, vessel_service, created at
 * @return collection of rates
 * @param rates_from_graphql
 */

export const update_vessel_Service_vendor_contract = async (
  rate_object,
  vessel
) => {
  if (vessel === true) {
    rate_object.vessel_service = {
      id: rate_object.carrier.id,
      name: rate_object.carrier.company_name,
    };
  } else {
    rate_object.vendor_contract = {
      id: rate_object.carrier.id,
      name: rate_object.carrier.company_name,
    };
  }
};

export const de_duplicates_rates = async (rates_from_graphql, requestFromClient = false) => {
  const final_rates = [];
  for (let pos = 0; pos < rates_from_graphql.length; pos++) {
    if (rates_from_graphql[pos].vessel_service === null) {
      await update_vessel_Service_vendor_contract(
        rates_from_graphql[pos],
        true
      );
    }
    if (rates_from_graphql[pos].vendor_contract === null) {
      await update_vessel_Service_vendor_contract(
        rates_from_graphql[pos],
        false
      );
    }
    if (pos === 0) {
      final_rates.push(rates_from_graphql[pos]);
    } else {
      for (let second_pos = 0; second_pos < final_rates.length; second_pos++) {
        if (final_rates[second_pos].vessel_service === null) {
          await update_vessel_Service_vendor_contract(
            final_rates[second_pos],
            true
          );
        }
        if (final_rates[second_pos].vendor_contract === null) {
          await update_vessel_Service_vendor_contract(
            final_rates[second_pos],
            false
          );
        }

        if (
          rates_from_graphql[pos].location_from.id ===
            final_rates[second_pos].location_from.id &&
          rates_from_graphql[pos].location_to.id ===
            final_rates[second_pos].location_to.id &&
          rates_from_graphql[pos].via_port.id ===
            final_rates[second_pos].via_port.id &&
          rates_from_graphql[pos].carrier.id ===
            final_rates[second_pos].carrier.id &&
          rates_from_graphql[pos].id !== final_rates[second_pos].id &&
          // rates_from_graphql[pos].vessel_service.id ===
          //   final_rates[second_pos].vessel_service.id &&
          (requestFromClient === false ? rates_from_graphql[pos].vessel_service.id === final_rates[second_pos].vessel_service.id : true) &&
          rates_from_graphql[pos].vendor_contract.id ===
            final_rates[second_pos].vendor_contract.id
        ) {
          if (
            rates_from_graphql[pos].created_at >
            final_rates[second_pos].created_at
          ) {
            final_rates[second_pos] = rates_from_graphql[pos];
          }

          break;
        }
        if (second_pos === final_rates.length - 1) {
          final_rates.push(rates_from_graphql[pos]);
          break;
        }
      }
    }
  }
  return final_rates;
  // return rates_from_graphql
};
export const Set_From_And_To_Parameter = (selectedPort) => {
  let linkedPort = selectedPort?.linkedPort;
  let portLinked = selectedPort?.portLinked;
  let linkedPortArray = [];

  if (linkedPort) {
    linkedPortArray = linkedPort.map((item) => ({
      id: item?.id,
      name: item?.companyName || item?.company_name,
      portCode: item?.scac_code
    }));
  }

  if (portLinked) {
    portLinked = {
      id: selectedPort?.portLinked?.id,
      name: selectedPort?.portLinked?.companyName || selectedPort?.portLinked?.company_name,
      portCode: selectedPort?.portLinked?.scac_code
    };
  }

  const selectedLocation = {
    id: selectedPort?.id,
    name: selectedPort?.name,
    portCode: selectedPort?.portCode
  };

  const locationPortArray = [
    ...(linkedPortArray || []),
    ...(portLinked ? [portLinked] : []),
    ...(selectedLocation ? [selectedLocation] : []),
  ];

  const uniqueLocations = new Set();

  // Use filter to get unique records based on the 'id' property
  const uniqueLocationPortArray = locationPortArray.filter((record) => {
    if (!uniqueLocations.has(record.id)) {
      uniqueLocations.add(record.id);
      return true;
    }
    return false;
  });

  return uniqueLocationPortArray;
};

export const Set_Input_parameter = async (inputparam, query_parameter) => {
  query_parameter.location_from = Set_From_And_To_Parameter(
    inputparam?.form_params?.pickup?.selectedPort
  );

  query_parameter.location_to = Set_From_And_To_Parameter(
    inputparam?.form_params?.delivery?.selectedPort
  );

  query_parameter.etd_origin = inputparam?.form_params?.pickup?.date;
  if (inputparam.form_params.type === "api-lcl") {
    query_parameter.rate_type = "LCL";
    query_parameter.mode = "sea";
  } else if (inputparam.form_params.type === "api-fcl") {
    query_parameter.rate_type = "FCL";
    query_parameter.mode = "Sea";
  } else {
    query_parameter.mode = "Air";
  }
  let date = new Date(query_parameter.etd_origin);
  let year = date.toLocaleString("default", { year: "numeric" });
  let month = date.toLocaleString("default", { month: "2-digit" });
  let day = date.toLocaleString("default", { day: "2-digit" });
  query_parameter.etd_origin = year + "-" + month + "-" + day;
  query_parameter.etd_origin = query_parameter.etd_origin.toString();
};
/**
 * @function
 * @name get_Client_Rate
 * @param getstate -> to get the current state,
 * @param inputparam -> to get the input parameters from users
 * @param loadmore -> to loadmore grapql query
 * @param dispatch
 * @description To query buying rates, based on parameter, and environment
 * @return return object, containing rates with global profit
 */

export const set_query_to_get_factory_details = async (client_id, query) => {
  query += "{";
  query += "allCompany(";
  query += "where:{ _and : [ {id:{eq:" + client_id.id + "}} \n   ]}";
  query += ")";
  query += "{";
  query += "results";
  query += "{";
  query +=
    "id\n companyName\n knownShippers{ id\n nameAndAddress\n phoneNumber\n postalCode\n businessLocationType\n linkedportid\n  email\n companyName\n city\n country\n address_1\n} location{ id\n nameAndAddress\n linkedPort{ id\n } businessLocationType\n phoneNumber\n postalCode\n city\n country\n email\n companyName\n address_1\n}";
  query += "}";
  query += "}";
  query += "}";

  return query;
};

export const map_loop_to_property = async (object, type) => {
  let new_object = {};

  new_object.address = object.address_1;
  new_object.business_type = object.businessLocationType;
  new_object.city = object.city;
  new_object.contact_name = object.companyName;
  new_object.country = object.country;
  new_object.email = object.email;
  new_object.id = object.id;
  new_object.name = object.nameAndAddress;
  new_object.phone_number = object.phoneNumber;
  new_object.postal = object.postalCode;
  new_object.isExistingFactorySelected = null;
  new_object.port = {};

  if (type === "PICK") {
    if (object.linkedPort !== undefined) {
      new_object.port.id = object.linkedPort.id;
    } else {
      new_object.port.id = null;
    }
  } else {
    if (object.linkedportid !== undefined) {
      new_object.port.id = object.linkedportid;
    }
    if (object.linkedPort === null) {
      new_object.port.id = null;
    }
  }

  return new_object;
};

export const set_properties_for_redux_store = async (user_data_for_form) => {
  let new_object = {};
  new_object.pickupExistingFactoryJson_old = user_data_for_form.knownShippers;
  new_object.deliveryExistingFactoryJson_old = user_data_for_form.location;
  new_object.pickupExistingFactoryJson = [];
  new_object.deliveryExistingFactoryJson = [];

  new_object.pickupExistingFactoryJson_old.map(async (value, index) => {
    new_object.pickupExistingFactoryJson.push(
      await map_loop_to_property(value, "PICK")
    );
  });

  new_object.deliveryExistingFactoryJson_old.map(async (value, index) => {
    new_object.deliveryExistingFactoryJson.push(
      await map_loop_to_property(value, "DEL")
    );
  });

  return new_object;
};

export const set_query_for_agent = async (param, query_param) => {
  query_param += "{";
  query_param +=
    "allCompany(" +
    "sort: { field: companyName, order: DESC }" +
    " where: {" +
    "_and: [" +
    '{entityType:{eq:"Country"}}' +
    '{companyName:{eq:"' +
    param.country +
    '"}}' +
    "]" +
    "}" +
    ")";
  query_param += "{";
  query_param += "results {";
  query_param += "companyName\n";
  query_param += "id\n";
  query_param += "linkedAgent{ id\n companyName\n email\n }";
  query_param += "}";
  query_param += "}";
  query_param += "}";

  return query_param;
};

export const get_Client_Rate = async (
  getstate,
  inputparam,
  loadmore,
  dispatch,
  set_client_only
) => {
  let query_parameter = {
    location_from: {},
    location_to: {},
    etd_origin: "",
    rate_type: "",
    mode: "",
    take: 100,
    skip: 0,
    user_data: {},
  };

  if (set_client_only === undefined) {
    await Set_Input_parameter(inputparam, query_parameter);
  }

  let jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
  if (jwt_token !== "" || jwt_token !== undefined) {
    let customer_profile_query = "";
    let response = {};
    let status_object = {};

    //Saving Networks call, when log-in user load the portal, it already save his to store,
    //to Avoid getting details twice these functions are implementing
    customer_profile_query = await Set_Query_For_Client(
      customer_profile_query,
      query_parameter,
      "DETAILS"
    );
    if (Object.keys(getstate().route.USER_DETAILS).length === 0) {
      response = await Make_Database_Call(jwt_token, customer_profile_query);
      status_object = await all_response_validation(response, "meWebuser");
    } else {
      status_object.bool = true;
      status_object.response = {
        data: {
          data: {
            meWebuser: {
              id: getstate().route.USER_DETAILS.webuser,
              email: getstate().route.USER_DETAILS.webuser,
              firstName: getstate().route.USER_DETAILS.webuser,
              lastName: getstate().route.USER_DETAILS.webuser,
              entity: getstate().route.USER_DETAILS,
            },
          },
        },
      };
    }
    if (status_object.bool) {
      if (status_object.response.data.data.meWebuser.entity !== undefined) {
        if (Object.keys(getstate().route.USER_DETAILS).length === 0) {
          let user_data = status_object.response.data.data.meWebuser.entity;
          user_data.webuser = {
            userid: status_object.response.data.data.meWebuser?.id,
            email: status_object.response.data.data.meWebuser?.email,
            firstName: status_object.response.data.data.meWebuser?.firstName,
            lastName: status_object.response.data.data.meWebuser?.lastName,
          };
          dispatch({
            type: SET_USER_DETAILS,
            payload: user_data,
          });

          if (user_data?.minimumCbm) {
            dispatch({
              type: UPDATE_LCL_SHIPMENT,
              payload: { totalVolume: user_data.minimumCbm },
            });
          }
          let query_for_user_details = "";
          query_for_user_details = await set_query_to_get_factory_details(
            user_data,
            query_for_user_details
          );
          let response_for_query = await Make_Database_Call(
            jwt_token,
            query_for_user_details
          );
          let status_object_for_user = await all_response_validation(
            response_for_query,
            "allCompany"
          );
          if (status_object_for_user.bool) {
            let user_data_for_form =
              status_object_for_user.response.data.data.allCompany.results[0];
            let change_properties = await set_properties_for_redux_store(
              user_data_for_form
            );
            dispatch({
              type: SET_EXISTING_JSON,
              payload: change_properties.pickupExistingFactoryJson,
            });

            dispatch({
              type: SET_DELIVERY_SELECTED_EXISTING_FACTORY_NEW,
              payload: change_properties.deliveryExistingFactoryJson,
            });
          } else {
            return {
              status: "404",
              error:
                "No User found, Error code 0012, please provide this id to prime freight ",
            };
          }
          // let get_know_shipper_and_factor_information_from_database=await set_query_for_user_details(user_data)
          // console.log(get_know_shipper_and_factor_information_from_database)
          if (set_client_only !== undefined) {
            return status_object;
          }
          query_parameter.user_data = user_data;
        } else {
          query_parameter.user_data = getstate().route.USER_DETAILS;
        }

        let query_for_agent_information = "";
        query_for_agent_information = await set_query_for_agent(
          getstate().route.queryParams.from,
          query_for_agent_information
        );
        let response_for_client_agent = await Make_Database_Call(
          getstate().route.JWT_TOKEN.JWT_TOKEN,
          query_for_agent_information
        );
        let status_object_for_agent = await all_response_validation(
          response_for_client_agent,
          "allCompany"
        );
        if (status_object_for_agent.bool) {
          let array_agents =
            status_object_for_agent.response.data.data.allCompany.results;
          if (array_agents.length > 0) {
            if (array_agents[0].linkedAgent !== null) {
              let final_object = {
                name: array_agents[0].linkedAgent.companyName,
                email: array_agents[0].linkedAgent.email,
                id: array_agents[0].linkedAgent.id,
              };
              dispatch({
                type: UPDATE_AGENT_DETAILS,
                payload: final_object,
              });
            }
          }
        }
        const result = await Set_Query_For_Client_Action(getstate, query_parameter, "RATES");
        if (result && result[0]=== 200) {
          if (result[1] && result[1].length>0) {
            let rates_from_bb = {   
              show_blur_cards: false,
              rates: {
                fcl: [],
                lcl: [],
              },
            };

            let rates_from_graphql = result[1];
            if(query_parameter?.rate_type === "FCL"  && rates_from_graphql.length >0){
              rates_from_graphql = await add_fcl_schedule_rates(rates_from_graphql, getstate, dispatch, true);
              // console.log("rates_with_schedules: ",rates_from_graphql)
            }
            // console.log("rates_with_schedules: ",rates_from_graphql)
            for (let pos = 0; pos < rates_from_graphql.length; pos++) {
              let rates_object = rates_from_graphql[pos];
              let quote_check = rates_object.quote;
              if (rates_object.chargetypes.carrier !== null) {
                rates_object = await Normalize_Data(rates_object);
                await setting_JSON_For_Redux_Store(
                  rates_object,
                  rates_from_bb,
                  pos,
                  query_parameter,
                  true,
                  quote_check
                );
              }
            }
            return {
              status: "200",
              response: rates_from_bb,
            };
          } else {
            console.log("in client buying");
            let response_from_buying = await get_buying_rate(
              getstate,
              inputparam,
              false,
              dispatch,
              true //send requestFromClient to true
            );
            return response_from_buying;
          }
        } else {
          return {
            status: result?.[0],
            error: "Error in getting all charges from db",
          };
        }
      } else {
        return {
          status: "404",
          error:
            "No User found, Error code 0011, please provide this id to prime freight ",
        };
      }
    } else {
      return {
        status: status_object.status,
        error: status_object.error,
      };
    }
  } else {
    return {
      status: "404",
      error: "No JWT found",
    };
  }
};

// export const write_query_for_transit_time=(all_data,query)=>{
//
//     query+="{"
//     query+="allSchedule"
//     query+="("
//     query+="sort:{field:etd, order:DESC}"
//     query+="where:{"
//     query+="_and:["
//     query+='{origin:{companyName:{eq:"'+all_data.port_origin+'"}}}'
//     query+='{discharge:{companyName:{eq:"'+all_data.port_discharge+'"}}}'
//     query+='{carrier:{companyName:{eq:"'+all_data.carrier+'"}}}'
//     query+='{etd:{gteq:"'+all_data.etd_origin+'"}}'
//     query+="]"
//     query+="}"
//     query+=")"
//     query+="{"
//     query+="results{"
//     query+="id\n"
//     query+="voyage\n"
//     query+="transitTime\n"
//     query+="vesselService{ id name }"
//     query+="}"
//     query+="}"
//     query+="}"
//
//     return query
// }

// export const iterate_over_rates = async (rates)=>{
//     let all_data_for_transit={
//         "port_origin":rates.port_of_origin,
//         "port_discharge":rates.port_of_discharge,
//         "port_destination":rates.ers_location,
//         "carrier":rates.sealine,
//         "etd_origin":rates.etd_origin
//     }
//     let query=""
//     query=write_query_for_transit_time(all_data_for_transit,query)
//     console.log(query)
// }

/**
 * @function
 * @name add_transit_time
 * @param graphql_response-> get the flash card after response
 * @description to query the transit time for all the rates
 * @return return same set of flash card with transit time added if available on database
 */

// export const add_transit_time = async (graphql_response)=>{
//     let all_rates=graphql_response.response.rates
//    if(all_rates.fcl.length > 0){
//       all_rates.fcl.forEach((value, index)=>{
//           iterate_over_rates(value)
//       })
//    }else {
//        all_rates.lcl.forEach((value, index)=>{
//            iterate_over_rates(value)
//
//        })
//    }
//
//     return graphql_response
// }

/**
 * @function
 * @name get_buying_rate
 * @param getstate -> to get the current state,
 * @param inputparam -> to get the input parameters from users
 * @param loadmore -> to loadmore grapql query
 * @description To query buying rates, based on parameter, and environment
 * @return return object, containing rates with global profit
 */

export const get_buying_rate = async (getstate, inputparam, loadmore, dispatch, requestFromClient = false) => {
  let query_parameter = {
    location_from: {},
    location_to: {},
    etd_origin: "",
    rate_type: "",
    mode: "",
    take: 100,
    skip: 0,
  };
  await Set_Input_parameter(inputparam, query_parameter);
  let jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN;
  if (jwt_token !== "" || jwt_token !== undefined) {
    const result = await get_chargetypes_for_air_and_Sea(query_parameter, getstate)
    if (result && result[0]=== 200) {
      if (result[1] && result[1].length>0) {
        let rates_from_bb = {
          show_blur_cards: false,
          rates: {
            fcl: [],
            lcl: [],
          },
        };

        let rates_from_graphql = result[1];
        rates_from_graphql = await de_duplicates_rates(rates_from_graphql, requestFromClient);

        if(query_parameter?.rate_type === "FCL"  && rates_from_graphql.length >0 && requestFromClient){
          rates_from_graphql = await add_fcl_schedule_rates(rates_from_graphql, getstate, dispatch);
        }
        for (let pos = 0; pos < rates_from_graphql.length; pos++) {
          await add_global_profit_on_buying_rates(
            rates_from_graphql[pos],
            getstate
          );
          let rates_object = rates_from_graphql[pos];
          rates_object = await Normalize_Data_Charge_Types(rates_object);
          await setting_JSON_For_Redux_Store(
            rates_object,
            rates_from_bb,
            pos,
            query_parameter,
            requestFromClient
          );
        }
        return {
          status: "200",
          response: rates_from_bb,
        };
      } else {
        return {
          status: "200",
          error: "No Rates found for specific port and period",
        };
      }
    } else {
      return {
        status: result?.[0],
        error: "Error while getting rates",
      };
    }
  }
  // when no jwt token find
  else {
    return {
      status: "404",
      error: "No JWT found",
    };
  }
};
